import { Button, Flex, Layout, Menu, Typography } from 'antd';
import styled from 'styled-components';

export const Container = styled(Flex).attrs({ vertical: true })`
  height: 100%;
  padding: 16px;
  background: #fff;
`;

export const VersionButton = styled(Button).attrs({
  type: 'primary',
  ghost: true,
})`
  width: 320px;
  border-radius: 2px;
  color: #525356 !important;
`;

export const VersionInfo = styled(Typography.Text).attrs({
  type: 'secondary',
})``;

export const ActionButtonWrapper = styled.div`
  padding: 8px;
  color: #999b9e;
  &:hover {
    color: ${(props) => props.theme.antd?.colorPrimary};
  }
`;
